import { isEmpty } from 'lodash'

export default {
  prepareShow (company) {
    company.bio = company.user.bio
    return company
  },
  prepareSave (company) {
    if (isEmpty(company.attachment.content)) {
      delete company.attachment
    }
    return company
  },

  afterSave (company) {
    this.show = true
    this.beenUpdated = true
  },
  afterUpdated () {
    this.show = true
    this.beenUpdated = true
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/companies/form/resources/methods.js